import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import DataSection from "./DataSection";
import DataTable from "./DataTable";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";

export default {
    mixins: [RouteToCustDetailMixins],
    props: {
        datas: {
            type: Array,
            default: () => []
        },
        _fields: {
            type: Array | Object,
            default: () => []
        }
    },
    components: { Avatar, DataTable, DataSection },
    data: () => ({
        refresh: true,
        isLoading: false,
        translate: {
            newContractType: {
                "0": "個人傷害險",
                "1": "團體傷害險",
                "2": "意外險",
                "3": "醫療險"
            },
            carContractType: {
                "0": "汽車險(強制險)",
                "1": "汽車險(任意險)",
                "2": "機車險(強制險)",
                "3": "機車險(附加傷害險)",
                "4": "機車險(任意險)",
                "5": "汽車險(附加傷害險)"
            },
            cepremamt: {
                "02": "滿期",
                "36": "滿期",
                "20": "展期",
                "21": "展期件滿期",
                "23": "繳清",
                "24": "繳清件滿期",
                "40": "主被保人身故",
                "42": "主被保人身故",
                "52": "主被保人完全失能",
                "53": "長期看護",
                "54": "重大疾病"
            },
            cebnfkd: {
                "1": "年金",
                "2": "滿期",
                "3": "身故",
                "4": "祝壽",
                "5": "配特身故",
                D: "身故(妻)",
                E: "祝壽(妻)"
            },
            relation: {
                "0": "本人",
                "1": "配偶",
                "2": "子女",
                "3": "父母",
                "7": "配偶父母"
            }
        }
    }),
    methods: {
        getCepremamt(infcd, isPrimaryContract) {
            if ("0" === infcd || "00" === infcd) {
                return isPrimaryContract ? "正常" : "有效";
            } else {
                return this.translate.cepremamt[infcd];
            }
        },
        getROCDate(date) {
            return moment(date).getROCDate();
        },
        getDate(date) {
            return moment(date).getADDate();
        },
        getROCDateCar(str) {
            if (!str) {
                return "";
            }
            str = str + "";
            return str.substr(0, str.length - 2) + "/" + str.substr(str.length - 2);
        },
        buildStartEndString(start, end) {
            return `起${start}<br>訖${end}`;
        },
        buildDeleteMessage(produceName) {
            return `您是否要刪除此筆主約「${produceName}」?`;
        },
        buildDeleteSubMessage(produceName) {
            return `您是否要刪除此筆附約「${produceName}」?`;
        },
        deleteSuccessHandler(fn) {
            return new Promise((resolve) => {
                fn.then((res) => {
                    if (res.header && res.header.status === "200") {
                        this.$toast.info({ title: "刪除成功" });
                        resolve();
                    } else {
                        this.$toast.info({ title: "刪除失敗" });
                    }
                });
            });
        },
        mergeString(...args) {
            return args.map(x => (x + '').padRight(20, "0")).join("_");
        }
    },
    watch: {
        datas: {
            handler: function() {
                this.refresh = false;
                this.$nextTick(() => {
                    this.refresh = true;
                });
            },
            deep: true,
        },
    },
};